export * from './GithubStudent';
